export const SHORT_LANGS_EN = {
  en: 'En',
  ru: 'Ru',
};
